import axios from 'axios'
import authService from '../auth.service'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_AMIO_COMMUNICATOR_API_URL || '', // '' bypasses CORS policy via proxy set in vue.config.js
  mode: 'no-cors'
})

httpClient.interceptors.request.use(config => {
  config.headers['Authorization'] = `Bearer ${localStorage.access_token}`
  return config
})

httpClient.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response?.status === 401) {
    // access token probably expired. Logout user.
    authService.logout()
    return Promise.resolve() // it avoids toast blinking while redirect to auth0 is in progress
  }

  return Promise.reject(error)
})

export default httpClient

